import { DatePicker, Select } from '@fourthwall/components';
import { isDateRangeValue, isPrecisionValue, mapDateRangeValueToPrecisionOptions, useDateRange, usePrecision, } from '@fourthwall/module-analytics';
import dayjs from 'dayjs';
import last from 'lodash-es/last';
import React, { useMemo } from 'react';
import { useAnalyticsParams } from '../../hooks/useAnalyticsParams';
import * as S from './RangeSelect.styled';
export const RangeSelect = ({ excludedPrecision }) => {
    const { dateRange } = useDateRange();
    const { precision } = usePrecision(dateRange.value, excludedPrecision);
    const { queryParams: { from: [fromParam, setFromParam], to: [toParam, setToParam], }, } = useAnalyticsParams();
    const rangePickerValue = useMemo(() => {
        const FORMAT = 'YYYY-MM-DD';
        const from = fromParam
            ? dayjs(dayjs.utc(fromParam).format(FORMAT)).startOf('day').add(12, 'hour').toISOString()
            : '';
        const to = fromParam
            ? dayjs(dayjs.utc(toParam).format(FORMAT)).startOf('day').add(12, 'hour').toISOString()
            : '';
        return [from, to];
    }, [fromParam, toParam]);
    const onSelectValueChange = (value) => {
        dateRange.select.onValueChange(value);
        setFromParam(value === 'custom' ? dateRange.params?.from || '' : undefined);
        setToParam(value === 'custom' ? dateRange.params?.to || '' : undefined);
        if (isDateRangeValue(value)) {
            const newPrecisionValue = last(mapDateRangeValueToPrecisionOptions(value, excludedPrecision))?.value;
            if (newPrecisionValue && isPrecisionValue(newPrecisionValue)) {
                precision.setValue(newPrecisionValue);
            }
        }
    };
    const onRangeValueChange = (dates) => {
        const value = dates.startDate > dates.endDate
            ? [dates.endDate, dates.startDate]
            : [dates.startDate, dates.endDate];
        const FORMAT = 'YYYY-MM-DD';
        const fromFormatted = value[0] ? dayjs(value[0]).format(FORMAT) : '';
        const from = fromFormatted ? dayjs.utc(fromFormatted).toISOString() : '';
        const toFormatted = value[1] ? dayjs(value[1]).format(FORMAT) : '';
        const to = toFormatted ? dayjs.utc(toFormatted).endOf('day').toISOString() : '';
        setFromParam(from);
        setToParam(to);
    };
    const renderRangePicker = () => {
        if (dateRange.value === 'custom') {
            return (React.createElement(DatePicker, { type: "range", startDate: rangePickerValue[0], endDate: rangePickerValue[1], size: "medium", startLabel: () => 'From', endLabel: () => 'To', showTimeInputs: false, dateFormat: "MMM D, YYYY", onDatesChange: onRangeValueChange }));
        }
        return null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(S.SelectContainer, null,
            React.createElement(Select, { label: "Date range (UTC)", options: dateRange.select.options, size: "medium", value: dateRange.value, onValueChange: onSelectValueChange })),
        renderRangePicker()));
};
